/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';
import { LOCATION_CHANGE } from 'react-router-redux';
import appReducer from 'containers/App/reducer';
import languageProviderReducer from 'containers/LanguageProvider/reducer';

import authReducer from 'shared-redux/src/auth/reducer';
import graphReducer from 'shared-redux/src/graph/reducer';
import vccReducer from 'shared-redux/src/vcc/reducer';
import videoElephantReducer from 'shared-redux/src/video-elephant/reducer';

/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

// Initial routing state
const routeInitialState = fromJS({
  location: null,
});

/**
 * Merge route into the global application state
 */
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return state.merge({
        location: action.payload,
      });
    default:
      return state;
  }
}

/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers) {
  return combineReducers({
    app: appReducer,
    auth: authReducer,
    graph: graphReducer,
    vcc: vccReducer,
    videoElephant: videoElephantReducer,
    route: routeReducer,
    language: languageProviderReducer,
    ...injectedReducers,
  });
}
